module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((this.latest), function(row, index) {
    return _c('div', {
      staticClass: "col-sm-12 col-xs-6"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "img"
    }, [(row.com_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    }) : _vm._e()]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v("電話: " + _vm._s(row.com_phone))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(row.c_website))])])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("進駐商城")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                        俗話說：「團結力量大」，現今台灣的消費者多數被財團剝削，將錢交到財閥手中，卻很少給消費者相對的回報。\n                        假若我們將消費者集結起來，運用團結的力量，即可改變現狀。讓獲利回饋給消費者以及讓我們的聯盟商消費圈更鞏固，體現「取之於社會，用之於社會」的理念。\n                    ")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("進駐表單")]), _vm._v(" "), _c('div', {
    staticClass: "apply_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputCo"
    }
  }, [_vm._v("公司/店面名稱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_name),
      expression: "com_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面名稱",
      "required": ""
    },
    domProps: {
      "value": (_vm.com_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoPhone"
    }
  }, [_vm._v("公司電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_phone),
      expression: "com_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "公司電話"
    },
    domProps: {
      "value": (_vm.com_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("公司簡介")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.introduction),
      expression: "introduction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司簡介"
    },
    domProps: {
      "value": (_vm.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.introduction = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoNum"
    }
  }, [_vm._v("統一編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_number),
      expression: "com_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "統一編號"
    },
    domProps: {
      "value": (_vm.com_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoAdd"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面地址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("網址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_site),
      expression: "com_site"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "官方網址"
    },
    domProps: {
      "value": (_vm.com_site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_site = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("聯絡人姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_name),
      expression: "contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "聯絡人姓名",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("聯絡人手機")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_phone),
      expression: "contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "聯絡人手機",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("聯絡人信箱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "聯絡人信箱",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "maxlength": "20",
      "placeholder": "請輸入您想要的密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("負責人會員編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reliablemanid),
      expression: "reliablemanid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "負責人會員編號",
      "required": ""
    },
    domProps: {
      "value": (_vm.reliablemanid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reliablemanid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("商品類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategory),
      expression: "productCategory"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "填寫商品類別",
      "required": ""
    },
    domProps: {
      "value": (_vm.productCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCategory = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("點數額")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricing),
      expression: "pricing"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pricing = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pricingList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.text
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + " 元\n                                                ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {}, [_vm._v("填寫表單前請先閲讀合約，一經填寫表單視同同意合約規定！並願意遵守！")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.apply()
      }
    }
  }, [_vm._v("我要加入")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2, false, false)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("加入聯盟")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("填寫表單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                      雙方合作方式為，愛幫您提供系統平台服務，給予聯盟商產品上刊與介紹，以及依據聯盟商活躍程度，提供曝光版面，另提供系統服務協助以利於聯盟商發展。"), _c('br'), _c('br'), _vm._v("\n                      聯盟商加入上架費六萬八千元整，首次限時加入享優惠價三萬一千元整，若重新上架費為十三萬元整。\n                      "), _c('strong', [_vm._v("聯盟正式方案者，付款方式統一為 ATM 或 臨櫃付款")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                      平台採預儲值系統最低金額以 10,000 元整，其儲值費用為聯盟商之產品成交時 發放回饋金抵扣之用，\n                      於合約執行期間點數額保留於愛幫您系統中平台代為發放給會員。"), _c('br'), _vm._v("當需與平台解除合約時，必須繳清所有欠費（上架費、行銷費、資訊費）以及扣除愛幫您額外給予之補助與福利後可將餘款退回給聯盟商。"), _c('br'), _vm._v("\n                      塡寫以下表單前，請先詳閱合約書，必要時可先下載紙本合約，一旦填寫，視為同意遵守合約條款的各項規定。\n                      "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("合約下載")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      若聯盟商家採用租賃模式(非一次繳清者)，則每月固定費用及單筆成交手續費做收取，使用負責人信用卡綁定進行款項收取。\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("31,000 聯盟首次優惠方案")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/EA81824"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("68,000 聯盟方案")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/941A9AF"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("130,000 聯盟方案")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/5799AAF"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-658a4ade"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Apply.vue
// module id = 297
// module chunks = 1